import { configFetch as fetch } from '@laigu/utils';

export const getSummaryContentByConvId = data => {
  return fetch({
    url: '/unified-api/conversations/v1/summary_generate',
    method: 'post',
    data
  });
};
